<template>
    <div class="Notificacion">
        <v-container grid-list-xl fluid class="pt-0">
            <v-layout row wrap>
                <v-flex sm12>
                    <v-card>
                        <v-toolbar color="primary" dark flat>
                            <v-toolbar-title>
                                <v-icon medium>fa-bell</v-icon>
                                Lista de Gestores
                            </v-toolbar-title>

                            <v-divider class="mx-2" inset vertical></v-divider>

                            <v-flex sm3 class="pa-0" style="max-width: 190px">
                                <v-overflow-btn
                                    v-model="notificacionEstado"
                                    label="Gestores"
                                    :items="[
                                        { text: 'Todos', value: '1' },
                                        { text: 'Activos', value: '2' },
                                        { text: 'Deshabilitados', value: '3' }
                                    ]"
                                    hide-details
                                    class="pa-0"
                                    @change="LoadGestorNotificacion"
                                >
                                    <template v-slot:item="data">
                                        <v-list-tile-content>
                                            <v-card-text class="pa-0 ">
                                                <v-icon
                                                    :color="getIconColor(data)"
                                                    class="pr-3"
                                                    v-if="data.item.value !== '1'"
                                                    >fa-list</v-icon
                                                >
                                                {{ data.item.text }}
                                            </v-card-text>
                                        </v-list-tile-content>
                                    </template>
                                </v-overflow-btn>
                            </v-flex>

                            <v-divider class="px-1 mr-2" inset vertical></v-divider>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon flat @click="openTiposNotificacion()">
                                        <v-icon medium v-on="on">fa-cog</v-icon>
                                    </v-btn>
                                </template>
                                <span>Gestionar Tipos de notificación</span>
                            </v-tooltip>

                            <v-divider class="px-1 mr-2" inset vertical></v-divider>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn icon flat @click="openNotificacion()">
                                        <v-icon medium v-on="on">fa-list-alt</v-icon>
                                    </v-btn>
                                </template>
                                <span>Ver notificaciones generadas</span>
                            </v-tooltip>

                            <v-divider class="px-1" inset vertical></v-divider>

                            <v-spacer></v-spacer>

                            <v-toolbar-items>
                                <v-btn icon @click="toogleSearch()">
                                    <v-icon medium>fa-search</v-icon>
                                </v-btn>

                                <v-expand-x-transition>
                                    <v-text-field
                                        hide-details
                                        solo
                                        v-show="searchShow"
                                        v-model="filter.search"
                                        placeholder="Filtrar"
                                        class="hidden-sm-and-down pt-2"
                                    >
                                    </v-text-field>
                                </v-expand-x-transition>

                                <v-menu
                                    v-model="filtroMenu"
                                    origin="center center"
                                    class="elelvation-1"
                                    transition="slide-y-transition"
                                    top
                                    left
                                    min-width="500"
                                    max-height="500"
                                    :close-on-content-click="false"
                                >
                                    <template v-slot:activator="{ on: menu }">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on: tooltip }">
                                                <v-btn icon flat>
                                                    <v-badge color="orange" overlap>
                                                        <span slot="badge" v-if="activeFilters > 0">{{
                                                            activeFilters
                                                        }}</span>
                                                        <v-icon medium v-on="{ ...tooltip, ...menu }">fa-filter</v-icon>
                                                    </v-badge>
                                                </v-btn>
                                            </template>
                                            <span>Filtro Personalizado</span>
                                        </v-tooltip>
                                    </template>
                                    <custom-filter-gestor-notificacion
                                        v-if="filtroMenu"
                                        :internal-state="filterInternalState"
                                        @applyFilter="applyFilter"
                                    ></custom-filter-gestor-notificacion>
                                </v-menu>

                                <v-divider class="pa-2"></v-divider>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn icon flat @click="openForm(null)">
                                            <v-icon medium v-on="on">fa-plus</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Agregar Gestor</span>
                                </v-tooltip>
                            </v-toolbar-items>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="headers"
                                :loading="loading"
                                :pagination.sync="pagination"
                                :rows-per-page-items="pagination.rowsPerPageItems"
                                :total-items="totalItems"
                                :items="GESTORES_NOTIFICACION"
                                class="elevation-1"
                                item-key="id"
                            >
                                <v-progress-linear v-slot:progress color="green" indeterminate></v-progress-linear>
                                <template slot="items" slot-scope="props">
                                    <tr>
                                        <td>{{ props.item.user ? props.item.user.username : "-" }}</td>
                                        <td>
                                            {{ props.item.tipo ? getCategoriaValue(props.item.tipo) : "-" }}
                                            <v-icon :disabled="menuLocked" @click="viewDetails(props, 1)"
                                                >fa-question</v-icon
                                            >
                                        </td>
                                        <td>{{ props.item.op_relacion ? props.item.op_relacion : "-" }}</td>
                                        <td>{{ props.item.valor_relacion ? props.item.valor_relacion : "-" }}</td>
                                        <td>
                                            {{
                                                props.item.condicion
                                                    ? formatStructure(props.item.condicion, ",", "")
                                                    : "-"
                                            }}
                                        </td>
                                        <td>
                                            <v-chip
                                                small
                                                dark
                                                :color="getChipColor(props.item)"
                                                style="font-size: 12px"
                                            >
                                                {{
                                                    props.item.status_description ? props.item.status_description : "-"
                                                }}
                                            </v-chip>
                                        </td>
                                        <td class="pl-0">
                                            <v-layout class="justify-end">
                                                <div class="action-column" style="width: 208px">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                flat
                                                                icon
                                                                color="grey"
                                                                :disabled="loading || menuLocked"
                                                                @click="viewDetails(props, 2)"
                                                            >
                                                                <v-icon medium v-on="on">fa-eye</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Ver detalles</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                flat
                                                                icon
                                                                color="orange"
                                                                :disabled="loading || menuLocked"
                                                                @click="openForm(props.item)"
                                                            >
                                                                <v-icon medium v-on="on">fa-edit</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Editar gestor</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                flat
                                                                icon
                                                                color="red"
                                                                :disabled="loading || menuLocked"
                                                                @click="deleteItem(props)"
                                                            >
                                                                <v-icon medium v-on="on">fa-trash</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Eliminar gestor</span>
                                                    </v-tooltip>
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{ on }">
                                                            <v-btn
                                                                flat
                                                                icon
                                                                color="grey"
                                                                :loading="loadingHistory"
                                                                :disabled="loading || menuLocked"
                                                                @click="loadHistory(props.item)"
                                                            >
                                                                <v-icon medium v-on="on">fa-archive</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>Ver historial</span>
                                                    </v-tooltip>
                                                </div>
                                            </v-layout>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:expand="props">
                                    <v-card>
                                        <v-card-text
                                            v-if="rowExpandedOption === 1"
                                            class="py-0 py-2 pl-0 text-xs-center"
                                            style="height: 44px"
                                        >
                                            <strong>Nombre. </strong>
                                            {{ props.item.nombre ? props.item.nombre : "-" }}
                                            <span> &ensp; &ensp; </span>
                                            <strong>Descripción. </strong>
                                            {{ props.item.descripcion ? props.item.descripcion : "-" }}
                                        </v-card-text>
                                        <v-card-text v-if="rowExpandedOption === 2" class="py-1 pl-0 text-xs-center">
                                            <v-chip small label dark>{{ getGestorExpression(props.item) }}</v-chip>
                                        </v-card-text>
                                        <v-card-text v-if="!rowExpandedOption" class="py-0 pl-0 text-xs-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="red" @click="deleteItemCancel(props)">
                                                        <v-icon v-on="on">fa-close</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Cancelar acción</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon flat color="green" @click="deleteItemConfirm(props)">
                                                        <v-icon v-on="on">fa-check</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Confirmar acción</span>
                                            </v-tooltip>
                                        </v-card-text>
                                    </v-card>
                                </template>
                                <template slot="no-data">
                                    <div style="text-align: center">
                                        No existen notificaciones registradas en el sistema.
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <gestor-notificacion-form
            v-if="showForm"
            :form-title="title"
            :initial-item="editItem"
            @formCanceled="closeForm"
        >
        </gestor-notificacion-form>

        <tipo-notificacion
            v-if="showTiposNotificacion"
            @formCanceled="showTiposNotificacion = false"
        ></tipo-notificacion>

        <time-line
            v-if="showHistory"
            :data="historyData"
            :element="'Notificación'"
            @formCanceled="showHistory = false"
        ></time-line>

        <notificacion v-if="showNotificaciones" @formCanceled="cancelNotificacionesform"></notificacion>
    </div>
</template>

<script>
import { mapGetters } from "vuex"
import _ from "lodash"
import Util from "@/util"
import Notificacion from "@/components/notificacion/notificacion"
const TipoNotificacion = () =>
    import(/* webpackChunkName: "notificacion-view" */ "@/components/notificacion/tipo-notificacion")
const GestorNotificacionForm = () =>
    import(/* webpackChunkName: "gestor-notificacion-form" */ "@/components/notificacion/gestor-notificacion-form")
const TimeLine = () =>
    import(/* webpackChunkName: "historiales-time-line" */ "@/components/widgets/records-time-line/time-line")
const CustomFilterGestorNotificacion = () =>
    import(/* webpackChunkName: "gestor-notificacion-filter" */ "@/components/widgets/custom-filter-notificacion/custom-filter-gestor-notificacion")

export default {
    components: { Notificacion, TipoNotificacion, GestorNotificacionForm, TimeLine, CustomFilterGestorNotificacion },
    props: {
        estado: { type: String, default: null }
    },
    data: () => ({
        searchShow: false,
        loading: false,
        title: "",
        showForm: false,
        headers: [
            { text: "Usuario", value: "user_id" },
            { text: "Categoría", value: "tipo_id" },
            { text: "Operador", value: "op_relacion" },
            { text: "Valor", value: "valor_relacion" },
            { text: "Condición", value: "condicion" },
            { text: "Estado", value: "estado" },
            { sortable: false }
        ],
        editItem: null,
        filter: {
            search: ""
        },
        totalItems: 0,

        deleteNotificacionConfirmId: "",

        menuLocked: false,

        //estado de los notificacions a cargar del back
        notificacionEstado: "2",

        //history
        loadingHistory: false,
        showHistory: false,
        historyData: null,

        //opcion para mostrar cuando se despliega la fila expand
        rowExpandedOption: null,

        //filtro personalizado
        filtroMenu: false,
        customFilter: null,
        activeFilters: 0,

        //para saber si ya se aplico el valor obtenido por las props
        estadoApplied: false,

        //chequear cumplimineto de la notificacion
        admNotificacionCheckShow: false,
        admNotificacionCheckData: null,

        //gestion de los tipos de notificacion
        showTiposNotificacion: false,

        //gestion de las notificaciones
        showNotificaciones: false,

        //estado interno del filtro
        filterInternalState: null
    }),

    methods: {
        toogleSearch: function() {
            this.searchShow = !this.searchShow
        },

        loadData(estado, customFilter) {
            this.loading = true
            this.$store
                .dispatch("LOAD_GESTORES_NOTIFICACION", {
                    filter: this.filter.search,
                    notificacionEstado: estado,
                    customfilter: customFilter
                })
                .then(result => {
                    this.loading = false
                    this.totalItems = result
                })
        },

        openForm(item) {
            if (item !== null) {
                this.title = "Modificar gestor"
                this.editItem = item
            } else {
                this.title = "Nuevo gestor"
            }
            this.showForm = true
        },

        closeForm() {
            this.showForm = false
            this.editItem = null
        },

        deleteItem(props) {
            this.rowExpandedOption = null
            this.menuLocked = true
            this.deleteNotificacionConfirmId = props.item.id
            props.expanded = true
        },

        deleteItemConfirm(props) {
            if (this.deleteNotificacionConfirmId === props.item.id) {
                this.loading = true
                this.$store.dispatch("DELETE_GESTOR_NOTIFICACION", props.item).then(() => {
                    this.loading = false
                    this.menuLocked = false
                    this.deleteNotificacionConfirmId = ""
                    props.expanded = !props.expanded
                })
            }
        },

        deleteItemCancel(props) {
            this.menuLocked = false
            this.deleteNotificacionConfirmId = ""
            props.expanded = !props.expanded
        },

        viewDetails(props, option) {
            if (!props.expanded) {
                this.rowExpandedOption = option
                props.expanded = true
            } else {
                this.rowExpandedOption = null
                props.expanded = false
            }
        },

        LoadGestorNotificacion() {
            this.loadData(this.notificacionEstado)
            this.customFilter = null
            this.activeFilters = 0
        },

        searchData: _.debounce(function() {
            this.loadData(this.notificacionEstado)
        }, 1000),

        getChipColor(item) {
            switch (item.estado) {
                case 1:
                    return "success lighten-1"
                case 0:
                    return "grey lighten-1"
            }
        },

        getIconColor(data) {
            switch (data.item.value) {
                case "1":
                    return "black"
                case "2":
                    return "success lighten-1"
                case "3":
                    return "grey lighten-1"
                default:
                    return "black"
            }
        },

        getPrioridadColor(item) {
            switch (item.tipoNotificacion.prioridad) {
                case 1:
                    return "yellow lighten-2"
                case 2:
                    return "yellow darken-2"
                case 3:
                    return "orange lighten-2"
                case 4:
                    return "orange darken-2"
                case 5:
                    return "red lighten-2"
                case 6:
                    return "red darken-2"
            }
        },

        getPrioridadTooltip(item) {
            switch (item.tipoNotificacion.prioridad) {
                case 1:
                    return "Prioridad baja. 1/6"
                case 2:
                    return "Prioridad baja. 2/6"
                case 3:
                    return "Prioridad media. 3/6"
                case 4:
                    return "Prioridad media. 4/6"
                case 5:
                    return "Prioridad alta. 5/6"
                case 6:
                    return "Prioridad alta. 6/6"
            }
        },

        openRowExpanded(props, option) {
            this.rowExpandedOption = option
            props.expanded = !props.expanded
        },

        loadHistory(item) {
            this.loadingHistory = true

            let historyClassName = Util.getHistoryClassName("GestorNotificacion")
            this.$store.commit("SET_HISTORIALES_TIME_LINE_PAG", { page: 1 })
            this.$store
                .dispatch("LOAD_HISTORIALES_TIME_LINE", { class: historyClassName, class_id: item.id })
                .then(response => {
                    if (response) {
                        this.historyData = this.$store.getters.HISTORIALES_TIME_LINE.historiales
                        this.showHistory = true
                        this.loadingHistory = false
                    } else {
                        this.loadingHistory = false
                    }
                })
        },

        applyFilter(value) {
            if (value.activeFilters > 0) {
                this.filtroMenu = false
                this.notificacionEstado = "6"
                this.customFilter = value.customFilter
                this.activeFilters = value.activeFilters
                this.loadData(this.notificacionEstado, this.customFilter)
            } else {
                this.notificacionEstado = "1"
                this.customfilter = null
                this.activeFilters = 0
                this.loadData(this.notificacionEstado, this.customfilter)
                this.filtroMenu = false
            }
            this.filterInternalState = { inputs: value.inputs, selectedCampos: value.selectedCampos }
        },

        openTiposNotificacion() {
            this.showTiposNotificacion = true
        },

        openNotificacion() {
            this.showNotificaciones = true
        },

        getCategoriaValue(item) {
            if (item && item.categoria) {
                return Util.getNotificationCategorie(null, item.categoria, this.BD_TABLES)
            } else return " "
        },

        getGestorExpression(item) {
            let relacion = `CANTIDAD (${this.getCategoriaValue(item.tipo)}) ${item.op_relacion} ${item.valor_relacion}`
            let condicion = ""
            if (item.condicion) {
                condicion += ` DONDE `
                let condicionesList = item.condicion.split(" ")
                condicionesList.unshift(".")
                for (let i = 0; i < condicionesList.length / 4; i++) {
                    if (i === 0) {
                        condicion += `(${this.formatStructure(condicionesList[4 * i + 1])} ${
                            condicionesList[4 * i + 2]
                        } ${condicionesList[4 * i + 3]}`
                    } else {
                        condicion += ` ${condicionesList[4 * i].toUpperCase()} ${this.formatStructure(
                            condicionesList[4 * i + 1]
                        )} ${condicionesList[4 * i + 2]} ${condicionesList[4 * i + 3]}`
                    }
                }
                condicion += `)`
            }
            return relacion + condicion
        },

        formatStructure(valor) {
            return valor.replace(new RegExp(",", "g"), " ")
        },

        /*si se cargo el filtro de las notificaciones alguna vez, recargar los gestore para poner en el store datos
        correctos. al utilizar ese filtro se cargan al store datos incompletos para la vista del index, que son
        utilizados en el select*/
        cancelNotificacionesform(value) {
            this.showNotificaciones = false
            if (value.filterLoaded) {
                this.LoadGestorNotificacion()
            }
        }
    },

    computed: {
        ...mapGetters(["GESTORES_NOTIFICACION", "BD_TABLES"]),

        pagination: {
            get: function() {
                return this.$store.getters.GESTORES_NOTIFICACION_PAG
            },
            set: function(value) {
                this.$store.commit("SET_GESTORES_NOTIFICACION_PAG", value)
            }
        },
        searchTerm() {
            return this.filter.search
        }
    },

    watch: {
        pagination: {
            handler() {
                if (this.estado && !this.estadoApplied) {
                    //si se envio el valor estado por las props y no se ha aplicado, se aplica una sola vez
                    this.notificacionEstado = this.estado
                    this.estadoApplied = true
                }
                this.loadData(this.notificacionEstado, this.customFilter)
            },
            deep: true
        },
        searchTerm() {
            this.searchData()
        }
    },

    created() {
        this.$store.dispatch("LOAD_BD_TABLES")
    }
}
</script>
